import type { AppState } from '@/types'
import { byId } from '@/utils/dom'

export type NavigateCallback = (page: AppState['currentPage']) => void

export class AboutPage {
  private el: HTMLElement
  private onNavigate: NavigateCallback

  constructor(onNavigate: NavigateCallback) {
    this.onNavigate = onNavigate
    this.el = byId('page-about')
    this.bindEvents()
  }

  private bindEvents(): void {
    byId('btn-about-to-home').addEventListener('click', () => this.onNavigate('home'))
    byId('btn-about-to-game').addEventListener('click', () => this.onNavigate('game'))
  }

  /** Enable/disable "进入游戏" based on whether a room is configured */
  updateGameBtn(hasRoom: boolean): void {
    const btn = this.el.querySelector<HTMLButtonElement>('#btn-about-to-game')
    if (btn) btn.disabled = !hasRoom
  }
}
